import type { ReactElement } from 'react';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import './help-link-button.scss';

type Props = {
  href?: string;
  className?: string;
};

export default function HelpLinkButton({
  className,
  href = 'https://nzcer.freshdesk.com/support/home'
}: Props): ReactElement {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={clsx('help-link-button rounded-pill', className)}
    >
      <span className="help-text">Help</span>
      <FontAwesomeIcon icon="circle-info" />
    </a>
  );
}
